import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pr_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Auto-attach the active workspace/region to GET requests so lists, stats,
  // and map endpoints all filter consistently. Backend re-scopes for
  // non-super_admin users so this param is purely a Super-Admin convenience.
  // Endpoints that don't recognise `region` simply ignore the extra param.
  try {
    const ws = localStorage.getItem("pr_workspace");
    if (ws && ws !== "all") {
      const method = (config.method || "get").toLowerCase();
      if (method === "get") {
        config.params = { ...(config.params || {}) };
        if (config.params.region === undefined) config.params.region = ws;
      }
    }
  } catch {}
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("pr_token");
      // best-effort redirect — handled by AuthContext check too
    }
    return Promise.reject(e);
  }
);

export default api;

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}
